import storage from "redux-persist/lib/storage";

import {
    CurrentUserInterface,
    HeaderInterface,
    OfflineDataSourceFieldMappingInterface,
    OfflineDataSourceInterface,
} from "@/interfaces";
import { updateStateHandler } from "@/lib/utils";
import {
    CHANGE_HEADER_TITLE,
    SET_CURRENT_USER_INFO,
    SET_OFFLINE_DATASOURCE_INFO,
    TOGGLE_SIDEBAR,
    UPDATE_OFFLINE_DATASOURCE_FIELD,
    UPDATE_OFFLINE_MAPPING_DATA_SOURCE_VIEW_NEXT_BTN_DATA,
} from "@/redux/types";

export const initialState = {
    header: {
        fallbackUrl: "",
        flexDirection: "row",
        hasBackBtn: false,
        loading: false,
        otherData: "",
        title: "",
    },
    isSideBarCollapsed: false,
    key: "root",
    offlineDataSource: {
        allTags: [],
        dataSourceType: "",
        fields: {},
        fileData: {
            open: false,
            url: "",
        },
        nextBtnData: {
            action: undefined,
            disabled: false,
        },
        sessionId: "",
        statusMapping: {
            allStatuses: [],
            ignoreUnMappedValues: false,
            pendingFields: [],
            postedFields: [],
        },
        unmappedTags: [],
    },
    storage,
    user: {
        createdTimestamp: new Date(),
        email: "",
        emailVerified: false,
        enabled: false,
        firstName: "",
        id: "",
        isAdmin: false,
        isAuthenticated: false,
        lastName: "",
        role: "",
        username: "",
    },
    whitelist: [],
};

export const rootReducer = (state = initialState, action: {
    payload?: {
        fieldData?: { key: string, value: OfflineDataSourceFieldMappingInterface},
        header?: HeaderInterface,
        nextBtnData?: {
            action?: () => void,
            disabled: boolean,
        };
        offlineDataSource? : OfflineDataSourceInterface,
        user?: CurrentUserInterface;
    },
    type: string,
}) => {
    const {
        payload,
        type,
    } = action;

    const {
        fieldData,
        header,
        nextBtnData,
        offlineDataSource,
        user,
    } = payload || {};

    switch (type) {
    case CHANGE_HEADER_TITLE: return updateStateHandler(
        state,
        { header },
    );
    case SET_CURRENT_USER_INFO:
        return updateStateHandler(
            state,
            { user },
        );
    case SET_OFFLINE_DATASOURCE_INFO:
        return updateStateHandler(
            state,
            { offlineDataSource },
        );
    case UPDATE_OFFLINE_DATASOURCE_FIELD: {
        const {
            key,
            value,
        } = fieldData || {};

        if (!key) return state;

        const newOfflineDataSource = {
            ...state.offlineDataSource,
            fields: {
                ...state.offlineDataSource.fields,
                [key]: value,
            },
        };

        return updateStateHandler(
            state,
            { offlineDataSource: newOfflineDataSource },
        );
    }
    case UPDATE_OFFLINE_MAPPING_DATA_SOURCE_VIEW_NEXT_BTN_DATA:
        return updateStateHandler(
            state,
            {
                offlineDataSource: {
                    ...state.offlineDataSource,
                    nextBtnData,
                },
            },
        );
    case TOGGLE_SIDEBAR:
        return updateStateHandler(
            state,
            { isSideBarCollapsed: !state.isSideBarCollapsed },
        );
    default: return state;
    }
};
